const steps = {
  WaitFor: 'Ожидание платежа от банка',
  Delay: 'Отсчёт времени жизни кода',
  SettleOrderPayment: 'Разнесение оплаты',
  Sequence: 'Развилка: событие или таймаут',
  InlineStepBody: 'Служебный шаг',
  ActionStepBody: 'Служебный шаг',
}

const statuses = {
  Legacy: { text: 'Устаревший', color: 'secondary' },
  Pending: { text: 'Ожидает', color: 'secondary' },
  Running: { text: 'Выполняется', color: 'info' },
  Complete: { text: 'Выполнен', color: 'success' },
  Sleeping: { text: 'Спит', color: 'info' },
  WaitingForEvent: { text: 'Ждёт событие', color: 'info' },
  Failed: { text: 'Ошибка', color: 'error' },
  Compensated: { text: 'Откачен', color: 'warning' },
  Cancelled: { text: 'Отменён', color: 'warning' },
}

const workflowStatuses = {
  Runnable: { text: 'Идёт', color: 'info' },
  Suspended: { text: 'Остановлен', color: 'warning' },
  Complete: { text: 'Завершён', color: 'success' },
  Terminated: { text: 'Отменён', color: 'secondary' },
}

export const stepName = value => steps[value] || value || '—'

export const stepStatus = value => statuses[value] || { text: value || '—', color: 'secondary' }

export const workflowStatus = value => workflowStatuses[value] || { text: value || '—', color: 'secondary' }

export const workflowStatusItems = [
  { text: 'Все', value: null },
  ...Object.keys(workflowStatuses).map(value => ({ text: workflowStatuses[value].text, value })),
]

export const isExpected = status => status !== 'Failed'
